
import { Component, Inject } from '@angular/core';
import { SharedLavorazioniModule } from '../../../../lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConnectServerService } from '../../../../../../../services/connect-server.service';
import { ApiResponse } from '../../../../../../../interfaces/api-response';

@Component({
    selector: 'app-dialog-info-event',
    imports: [
    SharedLavorazioniModule,
    MatDialogModule,
    DragDropModule
],
    templateUrl: './dialog-info-event.component.html',
    styleUrl: './dialog-info-event.component.scss'
})
export class DialogInfoEventComponent {
  eventData: any = null;
  isSmallScreen: boolean = false;
  idevent: number = 0;

  constructor(public dialogRef: MatDialogRef<DialogInfoEventComponent>,
    private connectServerService: ConnectServerService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.idevent = data.idevent;
  }

  ngOnInit(): void {
    if (this.idevent > 0) {
      this.getEventInfo(this.idevent);
    }
  }

  getEventInfo(idevent: number) {
    this.connectServerService.getRequestCookie('agenda/eventDetails', { idevent: idevent })
      .subscribe((val: ApiResponse<any>) => {
        if (val.data) {
          // console.log(val.data);
          this.eventData = val.data.infoEventCalendar;
        }
      })
  }
  getInternalTypeLabel(internal: number): string {
    switch (internal) {
      case 0:
        return 'CALENDAR.VIEWEVENT.EXTERNAL';
      case 1:
        return 'CALENDAR.VIEWEVENT.INTERNAL';
      case 2:
        return 'CALENDAR.VIEWEVENT.NOT_SPECIFIED';
      default:
        return 'CALENDAR.VIEWEVENT.NOT_SPECIFIED';
    }
  }
  onEdit() {
    this.dialogRef.close({ action: 'edit', idevent: this.idevent });
  }

  onClose() {
    this.dialogRef.close(null);
  }
}
